import React, { Component } from 'react';

import { availableLodging } from '../../Game/GamePlayerInfo';
import { LodgingPoolSelector } from
    '../Components/Controls/Actions/LodgingController';

import './choose-hotel.css';


/**
 * Manual 3.2 Initial Lodging Round picker.
 *
 * 2026-05-16: Replaced the standalone modal with the same
 * LodgingPoolSelector strip the normal Lodging action uses. The seat
 * still chooses a faction for its second Lodging Permit, but it now
 * looks and clicks like the normal Lodging pool picker so the player
 * doesn't get a one-off modal in round 1 and then a different UI for
 * the rest of the game.
 */
export default class InitialLodgingChoice extends Component {

    constructor(props) {
        super(props);
        this.state = { submitted: false };
    }

    onLodgingPoolClick = (swiper) => {
        if (this.state.submitted) return;
        const available = availableLodging(this.props.gameData);
        const factionId = available[swiper.clickedIndex];
        if (!factionId) return;
        this.setState({ submitted: true });
        const gamePlayerApi =
            this.props.app.game.seatedController.gamePlayerApi;
        gamePlayerApi.initialLodgingChoice(factionId);
    }

    render() {
        const available = availableLodging(this.props.gameData);
        // `lodging-pools-border-dashed` is defined in lodging-action.css
        // (transitively loaded via LodgingPoolSelector). Scoped here so
        // only the Initial Lodging strip gets the marching STEM border;
        // Fate-driven add/juice pool pickers stay untouched.
        return <div className={
                'initial-lodging-choice lodging-pools-border-dashed'}>
            <LodgingPoolSelector
                availableLodging={available}
                onLodgingPoolClick={this.onLodgingPoolClick}
            />
        </div>;
    }
}
